import ProviderAPI from "../redux/ProviderAPI";

export const getYachtInfoDestinationPackage = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "yachtInfoDestinationPackage/detailYachtInfoDestinationPackage",
    data,
    token,
  });
  return result;
};
